import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const Policies = () => {
  const policyFiles = [
    'Anti Bribery and Corruption Policy.pdf',
    'Compensation and Remuneration Policy.pdf',
    'Compromise Settlements_Technical Write Off.pdf',
    'Corporate Governance Policy.pdf',
    'Fair Practice Code.pdf',
    'Grievance Redressal Policy.pdf',
    'Information Technology Policy.pdf',
    'Interest Rate Policy.pdf',
    'KYC and AML Policy.pdf',
    'NPA Policy.pdf',
    'Policy on Appointment of Statutory Auditors.pdf',
    'Policy on Loan to Directors.pdf',
    'Related Party Policy.pdf',
    'Whistle Blower Policy.pdf',
  ];

  const policies = policyFiles.map((file) => ({
    name: file.replace(/\.pdf$/i, ''),
    path: `/Policies/${encodeURIComponent(file)}`,
    icon: '📄',
  }));

  return (
    <div className="policies-page">
      {/* Banner Section */}
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">POLICIES</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {policies.map((policy, index) => (
              <a
                key={index}
                href={policy.path}
                target="_blank"
                rel="noopener noreferrer"
                className="policy-item policy-cta"
              >
                <div className="policy-icon">{policy.icon}</div>
                <div className="policy-name">{policy.name}</div>
                <div className="policy-arrow">↗</div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;
